import styled, { css } from 'styled-components';

const dropdownActive = (props) => (
  props.menuOpen &&
  css`
    color: #db011c;
    transform: rotate(180deg);
  `
);

const StyledToggleIconWrapper = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
`;

const StyledSeparator = styled.span`
  align-self: stretch;
  background-color: #ced4da;
  margin-bottom: 8px;
  margin-top: 8px;
  width: 1px;
  box-sizing: border-box;
`;

const StyledArrowWrapper = styled.div`
  opacity: .75;
  display: flex;
  margin-left: .85rem;
  margin-right: .85rem;
`;

const StyledArrow = styled.span`
  border-top: 7px dashed;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  transform: rotate(0deg);
  transition: transform .225s ease;
  ${(props) => dropdownActive(props)}
`;

export {
  StyledToggleIconWrapper,
  StyledSeparator,
  StyledArrowWrapper,
  StyledArrow,
};
